import {Routes} from '@angular/router';
import {HairdressersComponent} from './hairdressers.component';

/**
 * Tout ce qui vit sous /hairdressers est déclaré ici, en enfants.
 *
 * 'hairdressers/city' et 'hairdressers/:username' étaient auparavant des
 * routes sœurs de 'hairdressers' dans app.routes.ts. Le routeur consommait
 * alors le segment 'hairdressers' au titre de cette route-ci, ne trouvait
 * aucun enfant capable d'absorber le segment suivant, et abandonnait sans
 * revenir essayer les routes sœurres : l'URL retombait sur le catch-all.
 * Le SSR servait pourtant la bonne page — d'où un contenu correct affiché une
 * fraction de seconde, remplacé par la page 404 dès l'hydratation.
 *
 * En les déclarant comme enfants, tout se résout en une seule passe.
 * ⚠️ 'city' doit précéder ':username', qui capterait le segment.
 */
export const hairdressersRoutes: Routes = [
  {
    path: '',
    component: HairdressersComponent
  },
  {
    path: 'city',
    loadChildren: (): Promise<Routes> => import('../cities/cities.routes').then(r => r.CITIES_ROUTES)
  },
  {
    path: ':username',
    loadChildren: (): Promise<Routes> => import('../hairdresser-details/hairdresser-details.routes').then(r => r.hairdresserDetailsRoutes)
  }
];
